import { Autocomplete, TextField, Chip, Box } from "@mui/material";
import { Field } from "react-final-form";
import {
    AdminPanelSettings as AdminIcon,
    Code as DevIcon,
    AccountCircle as UserIcon
} from '@mui/icons-material';

export default function DataFilterSelect({
    name,
    label,
    options = [],
    defaultValue,
    required = false,
    databaseFilter = false,
    doFilter,
    sx,
    multiple = false
}) {
    // Função para obter ícone baseado no valor
    const getIcon = (value) => {
        switch (value) {
            case 'admin':
                return <AdminIcon fontSize="small" />;
            case 'dev':
                return <DevIcon fontSize="small" />;
            case 'user':
                return <UserIcon fontSize="small" />;
            default:
                return null;
        }
    };

    // Função para renderizar opção com ícone
    const renderOption = (props, option) => (
        <Box component="li" {...props} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {getIcon(option.value)}
            {option.label}
        </Box>
    );

    // Função para renderizar chip selecionado
    const renderTags = (value, getTagProps) =>
        value.map((option, index) => (
            <Chip
                {...getTagProps({ index })}
                key={option.value}
                icon={getIcon(option.value)}
                label={option.label}
                size="small"
                variant="outlined"
            />
        ));

    return (
        <Field name={name}>
            {(props) => (
                <Autocomplete
                    multiple={multiple}
                    options={options}
                    getOptionLabel={(option) => option?.label || ''}
                    isOptionEqualToValue={(option, value) => option?.value === value?.value}
                    value={props.input.value || (multiple ? [] : null)}
                    onChange={(event, value) => {
                        props.input.onChange(value);
                    }}
                    renderOption={renderOption}
                    renderTags={multiple ? renderTags : undefined}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            defaultValue={defaultValue}
                            variant="standard"
                            sx={{ mt: 1 }}
                            error={props.meta.error && props.meta.touched}
                            helperText={props.meta.touched ? props.meta.error : ""}
                        />
                    )}
                    sx={{ display: "inline-block", width: "100%", ...sx }}
                />
            )}
        </Field>
    );
}
